import React from "react";

import "./loginPage.css";

import LoginForm from "./LoginForm";
import Hint from "../utils/Hint/Hint";

const LoginPage = ({
  isAuthenticated,
  userRole,
  setAuthenticated,
  setUserRole
}) => {
  return (
    <div className="loginPage_wrapper">
      <Hint
        hintHeading="Welcome to the demo"
        hintText={`
        <div>
        This is a static demo version of the restaurant/e-commerce CMS/CRM system, developed by <a target="blank" href="https://zdcreatech.com/">Dmitry Zhukov</a>.
        </div>
        <div style="margin-top: .5em;">
        In this demo, the system supports role-based authentication for two types of users: admin user (full content-management and CRM functionality) and employee user (full current orders and partial menu management functionality).
        </div>
        <div style="text-align: center; margin-top: .5em;">Log in credentials:</div> 
        <div style="display: flex; flex-direction: row; justify-content: space-around; flex-wrap: wrap; align-items: flex-start;">
        <div style="margin: .5em; text-indent: 0;">
        For admin application:
        <br/> 
        username: admin
        <br/>
        password: admin 
        </div>
        <div style="margin: .5em; text-indent: 0;">
        For employee application: 
        <br/> 
        username: employee
        <br/> 
        password: employee
        </div>
        </div>
        `}
        openOnMount={true}
        top="30%"
      />
      <div className="segment loginPage__containerSegment">
        <h3>Log in</h3>
        <LoginForm
          setAuthenticated={setAuthenticated}
          setUserRole={setUserRole}
        />
      </div>
    </div>
  );
};

export default LoginPage;
